module.exports = __webpack_public_path__ + "img/brands7.972166d1.png";